export default "__VITE_ASSET___M_LE6WY__"